/**
 * @flow
 * @relayHash 790e352b7bf57b415f372e281516dbb8
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type IBBrokerCashTransferList_viewer$ref = any;
export type IBBrokerCashTransferListQueryVariables = {|
  first?: ?number,
  offset?: ?number,
  search?: ?string,
  processedAt_Isnull?: ?boolean,
|};
export type IBBrokerCashTransferListQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: IBBrokerCashTransferList_viewer$ref
  |}
|};
export type IBBrokerCashTransferListQuery = {|
  variables: IBBrokerCashTransferListQueryVariables,
  response: IBBrokerCashTransferListQueryResponse,
|};
*/


/*
query IBBrokerCashTransferListQuery(
  $first: Int
  $offset: Int
  $search: String
  $processedAt_Isnull: Boolean
) {
  viewer {
    ...IBBrokerCashTransferList_viewer_3llZbG
    id
  }
}

fragment IBBrokerCashTransferList_viewer_3llZbG on Query {
  ibCashTransactions(first: $first, offset: $offset, orderBy: "-id", transType: "Deposits/Withdrawals", search: $search, processedAt_Isnull: $processedAt_Isnull) {
    edges {
      node {
        id
        createdAt
        updatedAt
        amount
        currency
        description
        brokeractivityPtr {
          id
          brokeractivitytransactionSet {
            edges {
              node {
                id
                createdAt
              }
            }
          }
        }
      }
    }
    count
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "processedAt_Isnull",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v2 = {
  "kind": "Variable",
  "name": "offset",
  "variableName": "offset"
},
v3 = {
  "kind": "Variable",
  "name": "processedAt_Isnull",
  "variableName": "processedAt_Isnull"
},
v4 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "IBBrokerCashTransferListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "IBBrokerCashTransferList_viewer",
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "IBBrokerCashTransferListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "ibCashTransactions",
            "storageKey": null,
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": "-id"
              },
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "Literal",
                "name": "transType",
                "value": "Deposits/Withdrawals"
              }
            ],
            "concreteType": "IBCashTransactionNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "IBCashTransactionNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "IBCashTransactionNode",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "updatedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "amount",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "currency",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "description",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokeractivityPtr",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerActivityNode",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "brokeractivitytransactionSet",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokerActivityTransactionNodeConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BrokerActivityTransactionNodeEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BrokerActivityTransactionNode",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v6/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "count",
                "args": null,
                "storageKey": null
              }
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "IBBrokerCashTransferListQuery",
    "id": null,
    "text": "query IBBrokerCashTransferListQuery(\n  $first: Int\n  $offset: Int\n  $search: String\n  $processedAt_Isnull: Boolean\n) {\n  viewer {\n    ...IBBrokerCashTransferList_viewer_3llZbG\n    id\n  }\n}\n\nfragment IBBrokerCashTransferList_viewer_3llZbG on Query {\n  ibCashTransactions(first: $first, offset: $offset, orderBy: \"-id\", transType: \"Deposits/Withdrawals\", search: $search, processedAt_Isnull: $processedAt_Isnull) {\n    edges {\n      node {\n        id\n        createdAt\n        updatedAt\n        amount\n        currency\n        description\n        brokeractivityPtr {\n          id\n          brokeractivitytransactionSet {\n            edges {\n              node {\n                id\n                createdAt\n              }\n            }\n          }\n        }\n      }\n    }\n    count\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7c53314f8831a9ee4ffddd56cb83ac97';
module.exports = node;
